module.exports = "<p>\n  manning-agency-app-posts-details works!\n</p>\n"